import "./RoboticsCourseHP4.module.css";
import Header from "@/reusable_sections/Header";
import RoboticsCourseHP4Detail from "./sections/RoboticsCourseHP4Detail";
import Footer from "@/reusable_sections/Footer";
export default function RoboticsCourseHP4Page() {
  return <div>
      <Header />
      <RoboticsCourseHP4Detail />
      <Footer />
    </div>;
}